import "../assets/styles/global.css";
import "@wordpress/block-library/build-style/common.css";
import "@wordpress/block-library/build-style/style.css";
import "@wordpress/block-library/build-style/theme.css";

import { Box, HStack, Heading, Text, VStack } from "@chakra-ui/react";

import Breadcrumbs from "../components/breadcrumbs/breadcrumbs";
import Layout from "../components/core/Layout";
import MainContentContainer from "../components/containers/main-content-container";
import React from "react";
import RelatedPost from "../components/blog/related-posts";
import { SEO } from "../components/seo/seo";
import SocialShareLink from "../components/blog/socials/socialshare-links";
import { graphql } from "gatsby";
import useLanguage from "../hooks/useLanguage";

function SingleBlogPost({ data }: any) {
  const isEnglish = useLanguage();
  const firstTag = data.wpPost.tags.nodes[0];

  const breadcrumbItems = [
    { label: isEnglish ? "Home" : "Почетна", href: isEnglish ? "/en/" : "/" },
    {
      label: firstTag ? firstTag.name : "Blog",
      href: firstTag ? `/${firstTag.slug}` : "/blog",
    },
    { label: data.wpPost.title, href: data.wpPost.slug },
  ];

  return (
    <Layout>
      <Box as="section" py={{ base: "40px", lg: "80px" }} bg="gray.50">
        <MainContentContainer>
          <VStack alignItems="flex-start" maxW="800px" gap="0px">
            <Breadcrumbs breadcrumbItems={breadcrumbItems} />

            <Heading
              as="h1"
              fontSize={{ base: "36px", lg: "56px" }}
              lineHeight="120%"
              letterSpacing="-1.5px"
              pt="8px"
              pb="12px">
              {data.wpPost.title}
            </Heading>
            <Text fontSize="14px" color="text.subtle">
              {data.wpPost.date}
            </Text>
            <SocialShareLink />
          </VStack>
        </MainContentContainer>
      </Box>

      <Box pt="40px" pb={{ base: "40px", md: "112px" }}>
        <MainContentContainer>
          <HStack
            flexDirection={{ base: "column", lg: "row" }}
            alignItems="flex-start"
            gap={{ base: "20px", md: "40px" }}>
            <Text
              maxW={{ base: "100%", lg: "60%", xl: "840px" }}
              w="100%"
              color="#4A5568"
              dangerouslySetInnerHTML={{ __html: data.wpPost.content }}></Text>
            <RelatedPost />
          </HStack>
        </MainContentContainer>
      </Box>
    </Layout>
  );
}

export default SingleBlogPost;

export const Head = ({ data }: any) => (
  <SEO
    title={data.wpPost.title}
    description={data.wpPost.excerpt}
    pathname=""
    children=""
  />
);

export const query = graphql`
  query SingleBlogPost($id: String!) {
    wpPost(id: { eq: $id }) {
      title
      modified
      slug

      featuredImage {
        node {
          sourceUrl
        }
      }
      categories {
        nodes {
          name
          slug
        }
      }
      tags {
        nodes {
          name
          slug
        }
      }
      content
      excerpt

      date(formatString: "D MMMM YYYY")
    }
  }
`;
